import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import {compose} from 'redux';
import {withAuth} from '../../../components/auth';
import {query} from './with-tripboard-query';

const removeUnitFromTripBoard = gql`
mutation removeUnitFromTripBoard($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {
    removeUnitFromTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad)
}`;

const props = ({mutate, ownProps}) => ({
    // just using onDelete as that is the expected legacy prop name, it would be nice to change this later
    onDelete: (tripBoardUuid, unitTriad) => {
        mutate({
            variables: {
                hav: ownProps.hav,
                tripBoardUuid,
                unitTriad
            },
            optimisticResponse: {
                removeUnitFromTripBoard: true
            },
            update: (proxy) => {
                try {
                    const variables = {
                        hav: ownProps.hav,
                        tripBoardUuid: ownProps.boardId,
                        currency: ownProps.currency
                    };
                    const data = proxy.readQuery({query, variables});
                    // remove listing from cache
                    data.tripBoard.listings = data.tripBoard.listings && data.tripBoard.listings.filter(({listingId}) => listingId !== unitTriad) || [];
                    data.tripBoard.listingRefs = data.tripBoard.listingRefs && data.tripBoard.listingRefs.filter((listingId) => listingId !== unitTriad) || [];
                    proxy.writeQuery({query, variables, data});
                } catch (err) {
                      /* we can't read or write the cache for some reason, silently swallow
                    and try to refetch the tripboard query from network in the refetchQueries function */
                }
            },
            refetchQueries: [{
                query,
                variables: {
                    hav: ownProps.hav,
                    tripBoardUuid,
                    currency: ownProps.currency
                }
            }]
        });
    }
});

const withTripboardListingDelete = compose(
    withAuth, // hav is extracted from auth context for use in query
    graphql(removeUnitFromTripBoard, {props})
);

export default withTripboardListingDelete;



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/with-tripboard-listing-delete.js